import { useQuery } from "@tanstack/react-query";
import { getAirportsForSelect } from "../../api/apiAirports";

const useGetAirportsForSelect = (cityId = null) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["airports-for-select", cityId],
        queryFn: () => getAirportsForSelect(cityId),
    });

    return {
        airports: data?.data || [],
        isLoading,
        error,
    };
};

export default useGetAirportsForSelect;
